import { defineMessages } from "react-intl";

export default defineMessages({
  title: {
    id: "Appointment.AppointmentCheckoutTimer.title",
    defaultMessage:
      "We have reserved your selected date and time for {reservedMinutes} minutes",
  },
});
